export default __webpack_public_path__ + "8eb4371cff7644e103045c9bf6e8fd7b.svg";